import { Component, OnInit, Input, Inject, PLATFORM_ID, OnDestroy, AfterViewInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { isPlatformServer } from '@angular/common';
import { JssContextService } from '../../jss-context.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/ApiService';
import { trigger,transition,style,animate } from '@angular/animations';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations:[
    trigger('menu-second-level', [
      transition(':enter', [
        style({ opacity: 0, height: '0px' }),
        animate('0.27s linear', style({ opacity: 1, height: '70px' }))
      ]),
      transition(':leave', [
        animate('0.14s linear', style({ opacity: 0, height: '0px' }))
      ])
    ]),
     trigger('modalContent', [
        transition(':enter', [
          style({ opacity: 0, transform: 'translate(-50%, -50%) scale(0)' }),
          animate('0.27s linear', style({ opacity: 1, transform: 'translate(-50%, -50%) scale(1)' }))
        ]),
        transition(':leave', [
          animate('0.17s linear', style({ opacity: 0, transform: 'translate(-50%, -50%) scale(0)' }))
        ])
      ]),
      trigger('backdropFade', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('0.27s linear', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          animate('0.17s linear', style({ opacity: 0 }))
        ])
      ])
  ]
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  _isPlatformServer: boolean = false;
  menuItems: any[] = [];
  isModalOpen: boolean = false;
  isBurgerMenuOpen: boolean = false;
  @Input() expandedIndex: number | null = null;
  hoveredItem: any = null;
  selectedItem: any = null;
  currentLink: any;
  currentLanguage: ILanguageModel;
  otherLanguage: ILanguageModel;
  en: ILanguageModel = {
      Text: "EN",
      TextMobile: "ENGLISH",
      Prefix: "en",
      DisplayPrefix: "en",
  };
  el: ILanguageModel = {
      Text: "EL",
      TextMobile: "ΕΛΛΗΝΙΚΑ",
      Prefix: "el",
      DisplayPrefix: "el",
  };
  isEditing: boolean;
  language: string;
  currentRoute: any;
  itemId: any;
  route: any;
  contextSubscription: any;
  params: any;
  secondLevelSelectedItem: any = null;
  h1TagInHtml: boolean = false;

  constructor(jssStylingService: JssStylingService,@Inject(PLATFORM_ID) public readonly platformId: string,private jssContext: JssContextService,public router: Router, protected apiService: ApiService, public activatedRoute: ActivatedRoute) { 
    this.jssStylingService = jssStylingService;
    platformId 
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('menu component initialized with component data', this.rendering);
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.isEditing = newState.sitecore && newState.sitecore?.context.pageEditing;
      this.language = newState.language;
      this.currentRoute = newState.serverRoute;
      this.itemId = newState.sitecore?.route?.itemId;
      this.route = newState.sitecore?.route;
      //this.toggleLanguage(null, this.language);
    });
    this.menuItems = (this.rendering.fields?.MenuItems as any).map((item:any) => ({
      Title: item?.fields?.Title?.value,
      LinkHref: item?.fields?.Link?.value?.href,
      Children: item?.fields?.SubItems.length ? item?.fields?.SubItems.map((subItem:any) => ({
        Title: subItem?.fields?.Title?.value,
        Active: subItem?.fields?.Active?.value,
        Href: subItem?.fields?.Link?.value?.href,
      })) : null
    }));
    this.activatedRoute.queryParams.subscribe((params) => {
      this.params = params["sc_params"];
  });
    console.log('menuItems:', this.menuItems);

    if(!this._isPlatformServer) {
      this.currentLink = document.location.pathname;

      this.menuItems.forEach((menuItem: any) => {
        if (this.currentLink.includes(menuItem.LinkHref)) {
          this.selectedItem = menuItem;
          menuItem?.Children?.forEach((secondMenuItem: any) => {
            if(this.currentLink.includes(secondMenuItem.Href)){
              this.secondLevelSelectedItem = secondMenuItem;
            }
          })
        }
      });
      this.h1TagInHtml = "/" + this.language + this.currentRoute == (this.rendering?.fields as any)?.LogoUrl?.value?.href;
    }
  }

  ngAfterViewInit(){
    this.toggleLanguage(null, this.language);
  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }

  toggleLanguage(selection: ILanguageModel, prefix: string) {
    prefix = prefix ? prefix : selection?.Prefix;
    if (prefix == this.en.Prefix) {
        this.currentLanguage = this.en;
        this.otherLanguage = this.el;
    } else {
        this.currentLanguage = this.el;
        this.otherLanguage = this.en;
    }
  }

  openSearchModal(event: Event): void {
    //debugger;
    event.preventDefault();
    if (!this._isPlatformServer) {
        document.querySelector<HTMLElement>("body").classList.add("eq-overflow-y-hidden");
        // this.fadeIn(document.querySelector("#eq-search-modal") as HTMLElement);
        // document.querySelector("#eq-search-modal").classList.remove("eq-moveup");
        // document.querySelector("#eq-search-modal").classList.add("eq-movedown");
        document.querySelector("#eq-search-modal").classList.remove("eq-hidden");
    }
}


  openModal() {
    this.isModalOpen = true;
  }
  closeModal() {
    this.isModalOpen = false;
  }
  expand(index: number){
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
  
  toggleBurgerMenu() {
    this.isBurgerMenuOpen = !this.isBurgerMenuOpen;
  }

  onItemClick(event: MouseEvent) {
    event.preventDefault();
    if(!this._isPlatformServer) {
      this.currentLink = document.location.pathname;
      this.menuItems.forEach((menuItem: any) => {
        if (this.currentLink.includes(menuItem.LinkHref)) {
          this.selectedItem = menuItem;
          menuItem.Children.forEach((secondMenuItem: any) => {
            if(this.currentLink.includes(secondMenuItem.Href)){
              this.secondLevelSelectedItem = secondMenuItem;
            }
          })
        }
      });
    }
    
  }

  onLanguageChange(e: any, selection: ILanguageModel) {
    e.preventDefault();
    if (this.isEditing) return;
    if (this.currentLanguage == selection) return;

    let filters: {
        Language: string;
        ItemID: string;
        LastSegment: string;
    };
    filters = {
        Language: selection.Prefix,
        ItemID: this.itemId,
        LastSegment: window.location.href.substring(window.location.href.lastIndexOf("/") + 1),
    };

    if (filters.LastSegment.includes("sc_params")) {
        filters.LastSegment = "";
    }

    this.toggleLanguage(selection,"");

    let route : string = (this.rendering?.fields?.result as any)?.alternateUrl;
    route = route != '/' ? ('/' + selection.DisplayPrefix + route) : (this.rendering.fields as any)?.LogoUrl?.value?.href;
    let currentParams = this.jssContext.decodeCustomParams(this.params);
    if (currentParams) {
        this.router.navigate([route], { queryParams: this.jssContext.customParamsToQueryStringObj(currentParams) });
    } else {
        this.router.navigateByUrl(route);
    }
    // this.apiService.fetch<any[]>("/eurobankequities/pagepath/get", filters).then((resp) => {
    //     if (resp.status === 200) {
    //         this.toggleLanguage(selection,"");
    //         let route : string = resp["data"].toString();
    //         route = route != '/' ? ('/' + selection.DisplayPrefix + route) : (this.rendering.fields as any)?.LogoUrl?.value?.href;
    //         let currentParams = this.jssContext.decodeCustomParams(this.params);
    //         if (currentParams) {
    //             this.router.navigate([route], { queryParams: this.jssContext.customParamsToQueryStringObj(currentParams) });
    //         } else {
    //             this.router.navigateByUrl(route);
    //         }
    //     }
    // });
  }
}

interface ILanguageModel {
  Text: string;
  TextMobile: string;
  Prefix: string;
  DisplayPrefix: string;
}